import { FC } from 'react';
import { BasketCartActions } from '@app/Types/Actions';
import { MyLink, LinkColors } from '@app/shared';
import IconLike from './icons/like.svg';

export const ActionItem: FC<BasketCartActions> = ({ name, code, shortName, newWindow = false, className }): JSX.Element => {
  return (
    <li className={className}>
      <MyLink color={LinkColors.Black} href={code || ''} target={newWindow && '_blank'}>
        <IconLike width={14} height={12.54} />
        <div>{shortName || name}</div>
      </MyLink>
    </li>
  );
};
